import { DateHelper } from '../misc/dateHelpers';
import { BaseItem, createBaseItem } from './baseItem';
import { Duplicate } from './duplicate';
import { ExtractedInformation } from './extractedInformation';
import { ReceiptDraft } from './receiptDraft';
import { ReceiptFile } from './receiptFile';
import { z } from 'zod';

export const Receipt = BaseItem.and(ReceiptDraft).and(
    z.object({
        /** Image url of scan/upload */
        files: z.array(ReceiptFile).nullish(),
        /** Detected duplications */
        duplicates: z.array(Duplicate).nullish(),
        /** Automatically extracted information from receipt images. */
        extractedInformation: ExtractedInformation.nullish(),
    }),
);
export type Receipt = z.infer<typeof Receipt>;

export function createReceipt(
    id: string,
    draft: ReceiptDraft | undefined,
    author: string,
    agent?: string | null,
): Receipt {
    return {
        ...createBaseItem(id),
        ...draft,
        history: [
            {
                action: 'create',
                author,
                agent: agent ?? undefined,
                date: DateHelper.now(),
                values: draft,
            },
        ],
    };
}
